import { Texture } from 'pixi.js';

// Power-of-two repeat source also works on GPUs without NPOT repeat support.
export const ISO_REPEAT_WIDTH=128;
export const ISO_REPEAT_HEIGHT=64;

export function paintIsoRepeatTile(context: Pick<CanvasRenderingContext2D,'fillStyle'|'fillRect'|'drawImage'>,image: CanvasImageSource): void {
  const w=ISO_REPEAT_WIDTH,h=ISO_REPEAT_HEIGHT;
  // Diamond PNG corners are transparent. An opaque backing prevents alpha seams
  // from revealing the fill's white default tint between packed diamonds.
  context.fillStyle='#8e8774';context.fillRect(0,0,w,h);
  for(const[x,y]of[[0,0],[w,0],[w/2,h/2],[0,h],[w,h]] as const)context.drawImage(image,x-w/2,y-h/2,w,h);
}

export function makeIsoRepeatTexture(source: Texture): Texture | null {
  const resource=source.source.resource as CanvasImageSource | undefined;
  if(!resource)return null;
  const canvas=document.createElement('canvas');canvas.width=ISO_REPEAT_WIDTH;canvas.height=ISO_REPEAT_HEIGHT;
  const context=canvas.getContext('2d');if(!context)return null;
  paintIsoRepeatTile(context,resource);
  const texture=Texture.from(canvas);
  texture.source.scaleMode='nearest';texture.source.style.addressMode='repeat';
  return texture;
}
